import userBackend, {PageItemUserInResponse} from '@lexian/api/user-api';
import {handlePaginatedLoadableFetch} from '_/utilities/simple-fetch';
import {
  defaultPaginationArguments,
  PaginatedLoadable,
  PaginationArguments,
} from '_/utilities/types';

export const searchUsers = (
  paginationArguments: Omit<
    PaginationArguments,
    'cursor'
  > = defaultPaginationArguments,
  currentLoadable: PaginatedLoadable<PageItemUserInResponse[]>,
  {searchQuery, ids}: {searchQuery: string; ids?: string[]}
): Promise<PaginatedLoadable<PageItemUserInResponse[]>> =>
  handlePaginatedLoadableFetch(
    {
      endpointFunction: userBackend.searchUsers,
      otherParams: {
        query: searchQuery,
        ids,
      },
      getPageItemFromResponse: (body) => body.users,
    },
    paginationArguments,
    currentLoadable
  );
